import { axios } from '@/utils/request'
const api = "/User"
export default {
    user_list: (parameter) => {
    return axios({
      url: `${api}/user_list`,
      method: 'post',
      data: parameter
    })
    },

    homepage_top: (parameter) => {
        return axios({
            url: `${api}/homepage_top`,
            method: 'post',
            data: parameter
        })
    },

    agent_list: (parameter) => {
        return axios({
            url: `${api}/agent_list`,
            method: 'post',
            data: parameter
        })
    },


    agent_top: (parameter) => {
        return axios({
            url: `${api}/agent_top`,
            method: 'post',
            data: parameter
        })
    },
    agent_access_list: (parameter) => {
        return axios({
            url: `${api}/agent_access_list`,
            method: 'post',
            data: parameter
        })
    },

    agent_access_top: (parameter) => {
        return axios({
            url: `${api}/agent_access_top`,
            method: 'post',
            data: parameter
        })
    },

    bind_seller: (parameter) => {
        return axios({
            url: `${api}/bind_seller`,
            method: 'post',
            data: parameter
        })
    },
    seller_list: (parameter) => {
        return axios({
            url: `${api}/seller_list`,
            method: 'post',
            data: parameter
        })
    },
    day_list: (parameter) => {
        return axios({
            url: `${api}/day_list`,
            method: 'post',
            data: parameter
        })
    },
    app_list: (parameter) => {
        return axios({
            url: `${api}/app_list`,
            method: 'post',
            data: parameter
        })
    },

    app_detail: (parameter) => {
        return axios({
            url: `${api}/app_detail`,
            method: 'post',
            data: parameter
        })
    },

    DelteUser: (parameter) => {
        return axios({
          url: `${api}/DelteUser`,
          method: 'post',
          data: parameter
        })
    },

    SaveUser: (parameter) => {
        return axios({
          url: `${api}/SaveUser`,
          method: 'post',
          data: parameter
        })
    },
}